import { Stack, Typography } from '@mui/material';
import { AuthCardStyled } from './auth-card.styled';
import { LogoAlt } from '@atoms/LogoAlt';

interface Props {
  children: React.ReactNode;
  title: string;
}

export const AuthCard = ({ children, title }: Props) => {
  return (
    <AuthCardStyled>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Typography variant="h2">{title}</Typography>
        <LogoAlt />
      </Stack>
      <div>{children}</div>
    </AuthCardStyled>
  );
};
